
import Category from "@/types/Category";
import { computed, defineComponent, PropType } from "vue";
import Multiselect from "../General/Multiselect.vue";

export default defineComponent({
  props: {
    suppliers: {
      type: Array as PropType<Category[]>,
      required: true,
    },
    modelValue: {
      type: Array as PropType<number[]>,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const value = computed({
      get: () => props.modelValue,
      set: (v) => {
        context.emit("update:modelValue", v);
      },
    });

    const search = (search: any, search2: any, search3: any, search4: any) => {
      console.log({ search, search2, search3, search4 });
    };

    return {
      value,
      search,
    };
  },
  components: { Multiselect },
});
